import styled, { css } from 'styled-components';

export const Container = styled.div`
   position: relative;
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 0.3rem;
   border-radius: 10px;
   box-shadow: 0 1px 1px #ccc;
   background-color: ${({ isUserSystem }) => isUserSystem ? ' #E7F8FF' : '#ffffff'};
   .skeleton--box{
      position:relative;
      display: flex;
      width: 225px;
      height: 225px;
      border-radius: 10px;
      justify-content: center;
      align-items: center;
      background-color: #e9ecef;
      .icon--{
         position: absolute;
         font-size: 4rem;
         z-index: 9;
         opacity: 0.2;
      }
   }
   .skeleton::before{
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 10px;
      content: "";
      height: 100%;
      width: 100%;
      background-color: #e9ecef;
      background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
      background-repeat: no-repeat;
      background-size: 450px 400px;
      animation: shimmer 2s linear infinite;
   }
   @keyframes shimmer {
      0%{
         background-position: -450px 0;
      }
      100%{
         background-position: 450px 0;
      }
   }

   .foB--{
      margin-top: 0.5rem;
      ${({ isUserSystem }) =>
      !isUserSystem &&
      css`
            position: absolute;
            bottom: 6px;
            right: 10px;
         `
   }
   }
   .fo--{
      width: 100%;
   }

   p{
      padding: 2px;
      font-size: 14px;
      word-break: break-word;
      white-space: pre-wrap;
      text-align: left;
      max-width: ${({ maxWidth }) => maxWidth ? maxWidth + 'px' : '225px'};
   }
`
export const Content = styled.div`
   position: relative;
   overflow: hidden;
   border-radius: 10px;

   ${({ maxWidth }) =>
      maxWidth &&
      css`
         max-width: ${maxWidth + 'px'};
      `
   }
   .actions__{
      position: absolute;
      display:flex;
      right: -150px;
      top: 0;
      width: 150px;
      height:2rem;
      justify-content: end;
      align-items: center;
      padding:0 0.5rem 0 0;
      border-radius: 0 10px 0 0;
      background: linear-gradient(15deg,transparent,transparent 45%,rgba(0,0,0,.12) 70%,rgba(0,0,0,.33));
      transition: right 0.3s ease-in-out;
      overflow: hidden;
      .icon--{
         font-size:1.3rem;
         cursor: pointer;
         color: #ffffff;
      }
   }
   &:hover{
      .actions__{
         right: 0;
      }
   }

   .loading__{
      position:relative;
      display:flex;
      width: 225px;
      height: 225px;
      border-radius: 10px;
      justify-content: center;
      align-items: center;
      background-color: #e9ecef;
   }
   .refresh__{
      display: flex;
      position: absolute;
      justify-content: center;
      align-items: center;
      font-size: 3rem;
      cursor: pointer;
      color: #9c9c9c;  
   }
   img{
      display: ${({ isRenderedImage }) => isRenderedImage ? 'flex' : 'none'};
      min-width: 225px;
      max-width: 350px;
      max-height: 400px;
      border-radius: 10px;
      cursor: pointer;
   }
`
export const LoadSpin = styled.div`
  border: 3.5px solid #9c9c9c; 
  border-top: 3.5px solid #0000; 
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`